"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarImageBase = exports.AvatarIconBase = void 0;
var React = __importStar(require("react"));
var View_1 = require("../View");
var icons_1 = require("../icons");
var avatarModes = {
    LIGHT: {
        color: 'n900',
    },
    DARK: {
        color: 'n300',
    },
};
var avatarIcons = {
    BOT: icons_1.AvatarBotIcon,
    USER: icons_1.AvatarIcon,
};
var SIZES = {
    LARGE: 40,
    MEDIUM: 32,
    SMALL: 24,
    EXTRA_SMALL: 20,
};
var AvatarIconBase = function (_a) {
    var _b = _a.icon, icon = _b === void 0 ? 'USER' : _b, _c = _a.size, size = _c === void 0 ? 'SMALL' : _c, _d = _a.mode, mode = _d === void 0 ? 'LIGHT' : _d, props = __rest(_a, ["icon", "size", "mode"]);
    var Icon = avatarIcons[icon];
    var color = avatarModes[mode].color;
    var calcSize = SIZES[size];
    return (React.createElement(View_1.View, __assign({ size: calcSize }, props),
        React.createElement(Icon, __assign({ size: calcSize, color: color }, props))));
};
exports.AvatarIconBase = AvatarIconBase;
var AvatarImageBase = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'SMALL' : _b, props = __rest(_a, ["size"]);
    var calcSize = SIZES[size];
    return (React.createElement(View_1.View, __assign({ as: "img", size: calcSize, borderRadius: "circle", padding: 'space2' }, props)));
};
exports.AvatarImageBase = AvatarImageBase;
//# sourceMappingURL=AvatarBase.js.map